import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const navigate = useNavigate();
	const [profile, setProfile] = useState(null);
	const [role, setRole] = useState("");
	const [token, setTokenState] = useState(
		localStorage.getItem("token") || null
	);

	const checkRole = (t) => {
		// Check roles from token
		setRole("Admin");
	};

	const setToken = (newToken) => {
		if (newToken) {
			localStorage.setItem("token", newToken);
		} else {
			localStorage.removeItem("token");
			navigate("/login", { replace: true });
		}
		setTokenState(newToken);
	};

	useEffect(() => {
		const storedToken = localStorage.getItem("token");
		if (!storedToken) {
			setToken(null);
		}
	}, []);

	useEffect(() => {
		if (token) {
			checkRole(token);
		}
	}, [token]);

	return (
		<AuthContext.Provider
			value={{ token, setToken, profile, setProfile, role, setRole }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
